import React from 'react';
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  tooltip: {
    width: '500px',
    minWidth: '500px',
    fontSize: '14px',
    whiteSpace: 'pre'
  }
});

class MyTooltip extends React.Component {
  render() {
    return (
      <Tooltip
        title={this.props.title}
        enterDelay={500}
        leaveDelay={200}
        placement="right"
      >
        <span>{this.props.children}</span>
      </Tooltip>
    );
  }
}

export default withStyles(styles)(MyTooltip);
